import { HubsAPI } from '$lib/api/rpc';
import { fetchWrapper } from '$lib/utils/fetchWrapper';
import RestApiClient from '$lib/api/restApi';
import type { LayoutLoad } from './$types';

export const load = (({ data, fetch }) => {
	const { apiUrl, jwt } = data;

	const api = new HubsAPI(apiUrl, fetchWrapper(fetch));

	const restApi = new RestApiClient(apiUrl, jwt, true, 'TODO');

	return { ...data, api, restApi };
}) satisfies LayoutLoad;
